// Filtros rápidos de fecha compartidos por las pantallas de reportes.
// Por defecto las pantallas arrancan en "Hoy": es lo más rápido (la semana
// actual se consulta en vivo y el histórico sale de la caché del servidor).
import React from 'react';
import { startOfDay, endOfDay, startOfWeek, startOfMonth, endOfMonth, subMonths } from 'date-fns';
import { cn } from '@/lib/utils';

export const DATE_PRESETS = [
    { id: 'hoy', label: 'Hoy', short: 'Hoy' },
    { id: 'semana', label: 'Esta semana', short: 'Semana' },
    { id: 'mes', label: 'Este mes', short: 'Mes' },
    { id: 'mes-anterior', label: 'Mes anterior', short: 'Mes anterior' },
];

export const DEFAULT_PRESET = 'hoy';

// Devuelve { from, to } (Date) para un preset. La semana empieza el lunes.
export function getPresetRange(preset, now = new Date()) {
    switch (preset) {
        case 'semana':
            return { from: startOfDay(startOfWeek(now, { weekStartsOn: 1 })), to: endOfDay(now) };
        case 'mes':
            return { from: startOfDay(startOfMonth(now)), to: endOfDay(now) };
        case 'mes-anterior': {
            const prev = subMonths(now, 1);
            return { from: startOfDay(startOfMonth(prev)), to: endOfDay(endOfMonth(prev)) };
        }
        case 'hoy':
        default:
            return { from: startOfDay(now), to: endOfDay(now) };
    }
}

export default function DatePresetButtons({ value, onChange, disabled = false, className }) {
    return (
        <div className={cn('inline-flex max-w-full flex-nowrap items-center gap-1 overflow-x-auto scrollbar-none rounded-lg border border-white/10 bg-white/5 p-1', className)}>
            {DATE_PRESETS.map((p) => (
                <button
                    key={p.id}
                    type="button"
                    disabled={disabled}
                    onClick={() => onChange(p.id, getPresetRange(p.id))}
                    className={cn(
                        'h-8 shrink-0 whitespace-nowrap rounded-md px-2.5 sm:px-3 text-sm font-medium transition-colors disabled:opacity-50 cursor-pointer',
                        value === p.id
                            ? 'bg-blue-600 text-white shadow-sm'
                            : 'text-white/60 hover:bg-white/10 hover:text-white'
                    )}
                >
                    <span className="sm:hidden">{p.short}</span>
                    <span className="hidden sm:inline">{p.label}</span>
                </button>
            ))}
        </div>
    );
}
